import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import Navbar from './common/Navbar';
import Footer from './common/Footer';
import HeroBanner from './home/HeroBanner';
import CategoryGrid from './home/CategoryGrid';
import OfferBanner from './home/OfferBanner';
import FeaturedProducts from './home/FeaturedProducts';
import Loader from './common/Loader';
import { getAllProducts } from '../services/api';

const Home = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await getAllProducts();
        if (response.data.data) {
          setProducts(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  if (loading) {
    return <Loader message="Loading fresh products..." />;
  }

  // Filter products for different sections
  const premiumProducts = products.filter(
    (p) => p.ProductCategory === 'Dry Fruits Premium' || p.ProductCategory?.CategoryName === 'Dry Fruits Premium'
  );

  const bulkProducts = products.filter(
    (p) => p.ProductCategory === 'Dry Fruits Bulk' || p.ProductCategory?.CategoryName === 'Dry Fruits Bulk'
  );

  // Best sellers (first 4 products)
  const bestSellers = products.slice(0, 4);

  // New arrivals (last 4 products)
  const newArrivals = [...products].reverse().slice(0, 4);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#faf8f5' }}>
      <Navbar />

      {/* Hero Banner */}
      <HeroBanner />

      {/* Category Grid */}
      <CategoryGrid />

      {/* Offer Banner */}
      <OfferBanner />

      {/* Best Sellers */}
      <FeaturedProducts
        title="Best Sellers"
        subtitle="Most Popular"
        products={bestSellers}
        viewAllLink="/filter/All"
        bgColor="#fff"
      />

      {/* Premium Dry Fruits */}
      {premiumProducts.length > 0 && (
        <FeaturedProducts
          title="Premium Dry Fruits"
          subtitle="Handpicked Quality"
          products={premiumProducts}
          viewAllLink="/filter/Dry Fruits Premium"
          bgColor="#faf8f5"
        />
      )}

      {/* Promotional Banner */}
      {/* <Box
        sx={{
          py: 8,
          background: 'linear-gradient(135deg, #8B4513 0%, #D2691E 100%)',
          textAlign: 'center',
          color: '#fff',
        }}
      >
        <Box sx={{ maxWidth: 600, mx: 'auto', px: 3 }}>
          <Box
            component="span"
            sx={{
              display: 'inline-block',
              bgcolor: 'rgba(255,255,255,0.2)',
              px: 3,
              py: 1,
              borderRadius: 5,
              fontSize: '0.9rem',
              fontWeight: 600,
              mb: 2,
            }}
          >
            Limited Time Offer
          </Box>
          <Box
            component="h2"
            sx={{
              fontSize: { xs: '1.8rem', md: '2.5rem' },
              fontWeight: 700,
              mb: 2,
              m: 0,
            }}
          >
            Get 20% Off on First Order
          </Box>
          <Box
            component="p"
            sx={{
              fontSize: '1.1rem',
              opacity: 0.9,
              mb: 3,
            }}
          >
            Use code <strong>WELCOME20</strong> at checkout
          </Box>
        </Box>
      </Box> */}

      {/* Bulk Dry Fruits */}
      {bulkProducts.length > 0 && (
        <FeaturedProducts
          title="Bulk Dry Fruits"
          subtitle="Great Value Packs"
          products={bulkProducts}
          viewAllLink="/filter/Dry Fruits Bulk"
          bgColor="#fff"
        />
      )}

      {/* New Arrivals */}
      {newArrivals.length > 0 && (
        <FeaturedProducts
          title="New Arrivals"
          subtitle="Just Landed"
          products={newArrivals}
          viewAllLink="/filter/All"
          bgColor="#faf8f5"
        />
      )}

      {/* Testimonials */}
      {/* <Testimonials /> */}

      {/* Footer */}
      <Footer />
    </Box>
  );
};

export default Home;
